import { observable, action } from 'mobx'

class Filter {
  @observable
  name
  @observable
  isEnabled
  fn

  constructor(name, callback) {
    this.name = name
    this.fn = callback
    this.isEnabled = true
  }

  @action
  setIsEnabled(isEnabled) {
    this.isEnabled = isEnabled
  }

  apply(ids, options = {}) {
    if (this.fn) {
      return this.fn(ids, options)
    }
  }
}

export default Filter
